import strings from "../../screenLocalisation/validation";
import validate from "validate.js";
import {
    CHECK_TOKEN_BEGAN, CHECK_TOKEN_REJECTED, CHECK_TOKEN_SUCCESS,
    DISCONNECT,
    LOGIN_BEGAN, LOGIN_FAILED,
    LOGIN_REJECTED, LOGIN_SUCCESS,
    REGISTER_BEGAN,
    REGISTER_FAILED,
    REGISTER_REJECTED,
    REGISTER_SUCCESS, SAVE_FIREBASE_TOKEN,
    CHANGE_PASSWORD_BEGAN,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAILED,
    SEND_NEW_PASSWORD_BEGAN,
    SEND_NEW_PASSWORD_SUCCESS,
    SEND_NEW_PASSWORD_FAILED
} from "../actionTypes/auth";
import axios from "axios";
import * as API from "../../constants/api";
// import Cookie from 'js-cookie';
import {connectedSelector, firebaseTokenSelector, tokenSelector, userIdSelector} from "../reducers/authReducer";

export const sendNewPasswordLink = (email) => {
    return async (dispatch) => {

        dispatch({
            type: SEND_NEW_PASSWORD_BEGAN
        })

        try {
            let response = await axios.post(API.sendNewPasswordLink(), {
                emailAddress: email,
            }, {headers: API.defaultHeaders})

            console.log(response)

            // let token = await Cookie.get('sails.sid')

            dispatch({
                type: SEND_NEW_PASSWORD_SUCCESS,
                payload: {linkSent: response.data}
            })
            //dispatch(sendToken())
        } catch (error) {
            dispatch({
                type: SEND_NEW_PASSWORD_FAILED,
                payload: error.response.data,
            })
        }
    }
}

export const changePassword = (token, password, passwordConfirmation) => {
    return async (dispatch, getState) => {


        dispatch({
            type: CHANGE_PASSWORD_BEGAN
        })

        if (password !== passwordConfirmation) {
            dispatch({
                type: CHANGE_PASSWORD_FAILED,
                payload: "passwords not match"
            })
            return
        }

        try {
            let response = await axios.post(API.changePassword(), {
                password: password,
                token: token
            }, {headers: API.defaultHeaders})


            // let token = await Cookie.get('sails.sid')


            dispatch({
                type: CHANGE_PASSWORD_SUCCESS,
                payload: {user: response.data}
            })
            //dispatch(sendToken())
        } catch (error) {

            dispatch({
                type: CHANGE_PASSWORD_FAILED,
                payload: error,
            })

        }

    }

}

export const register = (name, email, password, passwordConfirmation) => {
    return async (dispatch, getState) => {
        validate.options = {fullMessages: false}
        let check = validate({name, email, password, passwordConfirmation}, registerConstraints)

        dispatch({
            type: REGISTER_BEGAN
        })

        if(check != null){
            dispatch({
                type: REGISTER_REJECTED,
                payload: check
            })
            return
        }

        try {
            let response = await axios.post(API.signup, {
                fullName: name,
                emailAddress: email,
                password: password
            }, {headers: API.defaultHeaders})


            response = await axios.post(API.login, {
                emailAddress: email,
                password: password
            }, {headers: API.defaultHeaders})

            // let token = await Cookie.get('sails.sid')


            dispatch({
                type: REGISTER_SUCCESS,
                payload: {user: response.data}
            })
            //dispatch(sendToken())
        }catch(error){
            if(error.response && (error.response.status === 422 || error.response.status === 409)) {
                dispatch({
                    type: REGISTER_REJECTED,
                    payload: error.response.data,
                })
            }else if(error.response && error.response.status >= 500){
                dispatch({
                    type: REGISTER_FAILED,
                    payload: error,
                })
            }else if (error.response == null && error.request) {
                dispatch({
                    type: REGISTER_FAILED,
                    payload: error,
                })
            }else{
                console.log(error.request)
                throw error
            }
        }
    }
}


export const login = (email, password) => {
    return async (dispatch) => {
        validate.options = {fullMessages: false}
        let check = validate({email, password}, loginConstraints)

        dispatch({
            type: LOGIN_BEGAN
        })

        if (check != null) {
            dispatch({
                type: LOGIN_REJECTED,
                payload: check
            })
            return
        }

        try {
            let response = await axios.post(API.login, {
                emailAddress: email,
                password: password
            }, {headers: API.defaultHeaders})

            console.log(response)

            // let token = await Cookie.get('sails.sid')

            dispatch({
                type: LOGIN_SUCCESS,
                payload: {user: response.data}
            })
            //dispatch(sendToken())
        } catch (error) {
            if (error.response && (error.response.status === 422 || error.response.status === 401)) {
                dispatch({
                    type: LOGIN_REJECTED,
                    payload: error.response.data,
                })
            } else if (error.response && error.response.status >= 500) {
                dispatch({
                    type: LOGIN_FAILED,
                    payload: error,
                })
            } else if (error.response == null && error.request) {
                dispatch({
                    type: LOGIN_FAILED,
                    payload: error,
                })
            } else {
                console.log(error.request)
                throw error
            }
        }
    }
}

export const disconnect = () => {
    return {
        type: DISCONNECT
    }
}

export const checkToken = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: CHECK_TOKEN_BEGAN
        })

        if(!connectedSelector(getState())){
            dispatch({
                type: CHECK_TOKEN_REJECTED,
                payload: {unconnected: true},
            })
            return
        }

        try {
            // await Cookie.set('sails.sid', tokenSelector(getState()))

            let response = await axios.get(API.getUser(userIdSelector(getState())), {headers: API.defaultHeaders})

            // let token = await Cookie.get('sails.sid')


            dispatch({
                type: CHECK_TOKEN_SUCCESS,
                payload: {user: response.data.element}
            })
            //dispatch(sendToken())
        } catch (error) {
            if (error.response && (error.response.status === 422 || error.response.status === 401)) {
                dispatch({
                    type: CHECK_TOKEN_REJECTED,
                    payload: error.response.data,
                })
            } else if (error.response && error.response.status >= 500) {
                dispatch({
                    type: CHECK_TOKEN_REJECTED,
                    payload: error,
                })
            } else if (error.response == null && error.request) {
                dispatch({
                    type: CHECK_TOKEN_REJECTED,
                    payload: error,
                })
            } else {
                console.log(error.request)
                throw error
            }
        }
    }
}


const loginConstraints = {
    email: {
        presence: true,
        email: {
            message: strings.emailInvalid
        },
    },
    password: {
        presence: true,
        length: {
            minimum: 3,
            tooShort: strings.passwordShort
        },
    },
};


const registerConstraints = {
    email: {
        presence: true,
        email: {
            message: strings.emailInvalid
        },
    },
    name: {
        presence: true,
        length: {
            minimum: 3,
            tooShort: strings.usernameShort
        }
    },
    password: {
        presence: true,
        length: {
            minimum: 3,
            tooShort: strings.passwordShort
        },
    },
    passwordConfirmation: {
        equality: {
            attribute: 'password',
            message: strings.confirmPasswordNotEqual
        }
    }
};

export const saveFirebaseToken = (token) => {
    return {
        type: SAVE_FIREBASE_TOKEN,
        payload: token
    }
}

export const sendToken = () => {
    // Removed for web, only needed for mobile
    // return async (dispatch, getState) => {
    //     try{
    //         let userId = userIdSelector(getState())
    //         let firebaseToken = firebaseTokenSelector(getState())
    //         console.log(API.addDevice)
    //         let response = await axios.post(API.addDevice, {token: firebaseToken, User_id: userId}, {headers: API.defaultHeaders})
    //     }catch(error){
    //         // don't care
    //         console.log(error.response)
    //     }
    // }
}